import { PASSWORD_CHANGED } from 'common/messages';
import templateUrl from './reset-password.html';

export default {
  templateUrl,
  bindings: {
    credentials: '<'
  },
  controller: class ResetPasswordComponent {
    constructor($state, ResetPasswordService, ToastService) {
      'ngInject';

      Object.assign(this, { $state, ResetPasswordService, ToastService });
    }

    $onInit() {
      this.resetInvalidPasswordMessage();
    }

    resetInvalidPasswordMessage() {
      this.invalidNewPassword = false;
    }

    onSubmit() {
      this.invalidNewPassword = false;
      this.ResetPasswordService.changePassword({
        ...this.credentials
      }).then(() => {
        this.ToastService.showSuccess(PASSWORD_CHANGED);
        this.$state.go('login');
      }).catch((error) => {
        if (error && error.data && error.data.Message) {
          if (error.data.Message === 'Invalid New Password') {
            this.invalidNewPassword = true;
          }
        } else {
          this.ToastService.showError(error);
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./components/auth/reset-password/reset-password.component.js